module.exports = __webpack_public_path__ + "img/terroir-bright-2.445e1777.jpg";